import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { change, formValueSelector } from "redux-form";

const FORM = "statementForm";

export const ItemNumber = ({ index }) => (
    <div className="cro-array-item-number">{index + 1}</div>
);

export const useItemHandlers = (fields) => {
    const dispatch = useDispatch();
    const arrayName = fields ? fields.name : null;
    const items = useSelector((state) =>
        arrayName ? formValueSelector(FORM)(state, arrayName) : null
    );

    useEffect(() => {
        if (!items || !arrayName) return;
        items.forEach((item, idx) => {
            if (item && item.itemOrder == null) {
                dispatch(change(FORM, `${arrayName}[${idx}].itemOrder`, idx + 1));
            }
        });
    }, [arrayName]);

    const addItem = (extra = {}) => {
        fields.push({ ...extra, itemOrder: fields.length + 1 });
    };

    const removeItem = (index) => {
        const current = items || [];
        const next = current
            .filter((_, i) => i !== index)
            .map((item, idx) => ({ ...item, itemOrder: idx + 1 }));
        dispatch(change(FORM, arrayName, next));
    };

    return { addItem, removeItem };
};